/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import { ScannedForm } from 'cio/services/custom-forms';
import { tracked } from '@glimmer/tracking';

interface FormsCustomFormModalScannedFormOptionCardArgs {
  onSelect: () => unknown;
  isSelected: boolean;
  scannedForm: ScannedForm;
  isNew: boolean;
}

export default class FormsCustomFormModalScannedFormOptionCard extends Component<FormsCustomFormModalScannedFormOptionCardArgs> {
  @service auth!: AuthService;

  @tracked showAllFields = false;

  get moreFieldsCount() {
    return this.args.scannedForm.inputs.length - this.fields.length;
  }

  get fields() {
    if (!this.showAllFields) {
      return this.args.scannedForm.inputs.slice(0, 4);
    }

    return [...this.args.scannedForm.inputs];
  }

  get canSelect() {
    if (!this.args.isNew) {
      return this.auth.hasPermission('journeys/forms/edit');
    }

    return this.auth.hasPermission('journeys/forms/create');
  }
}
